import { ReactNode, MouseEventHandler } from 'react';
import styles from './Button.module.css';

interface ButtonProps {
	children: ReactNode;
	className?: string;
	onClick?: MouseEventHandler<HTMLButtonElement>;
	type?: 'button' | 'submit' | 'reset';
}

const Button = ({ children, className, onClick, type = 'button' }: ButtonProps) => {
	return (
		<button
			type={type}
			className={`${styles.button} ${className ? styles[className] : ''}`}
			onClick={onClick}
		>
			{children}
		</button>
	);
};

export default Button;
